import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Formik, Form, Field } from "formik";
import PropTypes from "prop-types";
import { cleanCNPJ } from "../../../utils/stringManipulations";
import { OutlineTextField, OutlineCPForCNPJ } from "../../FormikCustoms";
import FormModal from "../../FormModal";
import { validateCpfCnpj } from "./../../../utils/inputValidations";
import { isEmpty } from "lodash";

function ModalData({
  open,
  handleClose,
  handleSave,
  getClientByDocument,
  editedData,
  getTransporterByCNPJ,
  modalCaption,
  readOnly,
  actionButtonText,
  receiveFeedback
}) {
  const [feedback, setFeedback] = useState({});
  const [searchingClient, setSearchingClient] = useState(true);
  const [searchingTransporter, setSearchingTransporter] = useState(true);

  const handleOnFeedback = () => {
    if (feedback.success) {
      handleOnclose();
    } else {
      setFeedback({});
    }
  };


  const handleOnclose = () => {
    handleClose();
    setFeedback({});
  };

  const handleOnSubmit = async (values, setSubmitting) => {
    values.transporter_document = cleanCNPJ(values.transporter_document);
    values.client_document = cleanCNPJ(values.client_document);
    const feedback = handleSave(values);
    
    if (!feedback) {
      setFeedback({success: false, message: "Erro ao adicionar cota: Cliente e transportadora já adicionada."});
    } else {
      setFeedback({success: true, message: "Cota adicionada com sucesso."})
    }
  };

  const handleDocumentEntered = async (values, setFieldValue) => {
    const clientDocument = cleanCNPJ(values.client_document);
    if (clientDocument.length === 11 || clientDocument.length === 14) {
      const client = await getClientByDocument(clientDocument);
      setSearchingClient(true);

      if (!isEmpty(client)  || !isEmpty(client.name)) {
        setFieldValue('client_name', client.name);
      } else {
        setFieldValue('client_name', '');
        setSearchingClient(false);
      }
    }

  }


  const handleDocumentTransportationEntered = async (values, setFieldValue) => {
    const transportationDocument = cleanCNPJ(values.transporter_document);
    if (transportationDocument.length === 11 || transportationDocument.length === 14) {
      const shippingCompany = await getTransporterByCNPJ(transportationDocument);
      setSearchingTransporter(true);

      if (!isEmpty(shippingCompany)  || !isEmpty(shippingCompany?.name)) {
        setFieldValue('transporter_name', shippingCompany?.name);
      } else {
        setFieldValue('transporter_name', '');
        setSearchingTransporter(false);
      }
    }
  }


  const validateForm = (values) => {
    const errors = {};

    if (!values.client_name) {
      errors.client_name = "Cliente/Fornecedor é necessário.";
    }

    if (!values.client_document) {
      errors.client_document = "CNPJ/CPF do cliente é necessário";
    }

    if (values.client_document && !validateCpfCnpj(values.client_document)) {
      errors.document_number = "CNPJ/CPF do cliente precisa ser válido";
    }

    if (values.transporter_document && !validateCpfCnpj(values.transporter_document)) {
      errors.transporter_document = "CNPJ da transportadora precisa ser válido";
    }

    if (values.client_document && !validateCpfCnpj(values.client_document)) {
      errors.client_document = "CNPJ/CPF do cliente precisa ser válido";
    }


    return errors;
  };

  return (
    <FormModal
      title={modalCaption}
      open={open}
      handleClose={handleOnclose}
    >
      {!Object.keys(feedback).length ? (
        <Formik
          initialValues={{
            id: editedData.id ?? null,
            client_document: editedData.client_document ?? "",
            contract_number: editedData.contract_number ?? "",
            client_name: editedData.client_name ?? "",
            transporter_document: editedData.transporter_document ?? "",
            transporter_name: editedData.transporter_name ?? ""
          }}
          validate={(values) => validateForm(values)}
          onSubmit={(values, { setSubmitting }) =>
            handleOnSubmit(values, setSubmitting)
          }
        >
          {({ setFieldValue, submitForm, isSubmitting, values }) => (
            <Form
               data-cy="client-quota-form"
               id="client-quota-form"
            >
              <Grid container spacing={3} justifyContent="space-between">
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineCPForCNPJ}
                    name="client_document"
                    data-cy="client-quota-client-document"
                    id="client-quota-client-document"
                    type="tel"
                    label="CPF/CNPJ Cliente/Fornecedor *"
                    value={values.client_document}
                    onFocus={() => setSearchingClient(true)}
                    onBlur={() => handleDocumentEntered(values, setFieldValue)}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineCPForCNPJ}
                    mask="99.999.999/9999-99"
                    name="transporter_document"
                    type="text"
                    label="CNPJ Transportadora"
                    data-cy="client-quota-cnpj"
                    id="client-quota-cnpj"
                    value={values.transporter_document}
                    onFocus={() => setSearchingTransporter(true)}
                    onBlur={() => handleDocumentTransportationEntered(values, setFieldValue)}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="client_name"
                    data-cy="client-quota-client-name"
                    id="client-quota-client-name"
                    disabled={searchingClient || readOnly}
                    type="text"
                    label="Cliente/Fornecedor *"
                    value={values.client_name}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="transporter_name"
                    data-cy="client-quota-transporter-name"
                    id="client-quota-transporter-name"
                    disabled={true || searchingTransporter || readOnly} //Disabled in the release 2.7.
                    type="text"
                    label="Nome da Transportadora"
                    value={values.transporter_name}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={OutlineTextField}
                    name="contract_number"
                    type="text"
                    data-cy="client-quota-numero-contrato"
                    id="client-quota-numero-contrato"
                    label="Número de Contrato"
                    inputProps={{ maxLength: 20}}
                    value={values.contract_number}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <div
                    style={{
                      display: "flex",
                      height: 56,
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ minWidth: "100%" }}
                      data-cy="client-quota-close"
                      id="client-quota-close"
                      disabled={isSubmitting}
                      onClick={
                        () => {
                          if (!!readOnly) {
                            handleClose();
                          } else {
                            submitForm();
                          }
                        }

                      }
                      size="large"
                    >
                      {actionButtonText}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5">{feedback.message}</Typography>
            </Grid>
            <Grid item xs={12}>
              <div
                style={{
                  display: "flex",
                  height: 56,
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={handleOnFeedback}
                  variant="contained"
                  color="primary"
                  style={{ minWidth: "50%" }}
                  size="large"
                >
                  {feedback.success ? "Voltar" : "Tentar novamente"}
                </Button>
              </div>
            </Grid>
          </Grid>
        )}
    </FormModal>
  );
}

ModalData.defaultProps = {
  editedData: {},
};

ModalData.propTypes = {
  editedData: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  getClientByDocument: PropTypes.func.isRequired,
  modalCaption: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  actionButtonText: PropTypes.string.isRequired,
  receiveFeedback: PropTypes.bool.isRequired
};

export default ModalData;
